import { h } from 'hyperapp'

const Notice = ({ text, show }) => (
    <div class="notice" data-show={show}>
        { text }
    </div>
)

export default Notice



// WEBPACK FOOTER //
// ./src/scripts/components/notice.js